"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _ravenJs = _interopRequireDefault(require("raven-js"));
var _campaignStoreConstants = require("./campaign-store-constants");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _get = _interopRequireDefault(require("lodash/get"));
var _dataUtils = require("../utils/data-utils");
var _posthogUtils = require("../utils/posthog-utils");
var _signOffAnswerForm = _interopRequireDefault(require("./forms/sign-off-answer-form"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var CampaignStore = (_class = /*#__PURE__*/function () {
  function CampaignStore() {
    var _this = this;
    _classCallCheck(this, CampaignStore);
    _initializerDefineProperty(this, "activeQuestion", _descriptor, this);
    _initializerDefineProperty(this, "followupQuestion", _descriptor2, this);
    _initializerDefineProperty(this, "isReadyToSubmit", _descriptor3, this);
    _initializerDefineProperty(this, "isSubmitted", _descriptor4, this);
    _initializerDefineProperty(this, "lastDateOfAnswerForUser", _descriptor5, this);
    _initializerDefineProperty(this, "isSubmissionFailureModalOpen", _descriptor6, this);
    _defineProperty(this, "form", _signOffAnswerForm["default"]);
    _defineProperty(this, "setStore", function (store) {
      _this.store = store;
    });
    _initializerDefineProperty(this, "setLastDateOfAnswerForUser", _descriptor7, this);
    _initializerDefineProperty(this, "setActiveQuestion", _descriptor8, this);
    _initializerDefineProperty(this, "setIsReadyToSubmit", _descriptor9, this);
    _initializerDefineProperty(this, "setIsSubmitted", _descriptor10, this);
    _initializerDefineProperty(this, "setFollowupQuestion", _descriptor11, this);
    _initializerDefineProperty(this, "setIsSubmissionFailureModalOpen", _descriptor12, this);
    //reset functions
    _initializerDefineProperty(this, "resetQuestions", _descriptor13, this);
    _initializerDefineProperty(this, "resetActiveQuestion", _descriptor14, this);
    //triggerCampaign
    _defineProperty(this, "triggerEvent", function (_ref) {
      var eventName = _ref.eventName,
        campaign = _ref.campaign,
        instructionId = _ref.instructionId;
      var platform = _this.store.platform;
      var localStorageLog = _this.getLocalStorageLog().campaigns;
      _this.resetQuestions();
      switch (eventName) {
        case _campaignStoreConstants.INSTRUCTION_VIEWED:
          break;
        default:
          console.error('Unknown campaign event.');
      }
      if (platform.canAnswerSurveyQuestions && campaign) {
        var campaignLog = localStorageLog[campaign.id];
        if (_this.shouldShowCampaign(campaign.showPeriodSeconds, instructionId, campaignLog)) {
          _this.askQuestion(campaign);
        }
      }
    });
    _defineProperty(this, "shouldShowCampaign", function (showPeriodSeconds, instructionId, campaignLog) {
      if (!Number.isInteger(showPeriodSeconds) || !instructionId) {
        return false;
      }
      if (!campaignLog || !campaignLog.instructions[instructionId]) {
        return true;
      }
      var timeSinceLastQuestion = (Date.now() - campaignLog.instructions[instructionId]) / 1000;
      return showPeriodSeconds <= timeSinceLastQuestion;
    });
    _defineProperty(this, "askQuestion", function (campaign) {
      _this.setIsReadyToSubmit(false);
      _this.setIsSubmitted(false);
      _this.setActiveQuestion(campaign);
    });
    _defineProperty(this, "getLocalStorageLog", function () {
      var localStorageLog = JSON.parse(localStorage.getItem(_campaignStoreConstants.LOCAL_STORAGE_CAMPAIGN_QUESTION_LOG));
      return !localStorageLog || !_this.checkLocalStorageStructure(localStorageLog) ? (0, _campaignStoreConstants.getEmptyLocalStorageLogStructure)() : localStorageLog;
    });
    _defineProperty(this, "checkLocalStorageStructure", function (localStorageLog) {
      if (!localStorageLog.campaigns || !localStorageLog.campaigns.version || localStorageLog.campaigns.version !== _campaignStoreConstants.LOCAL_STORAGE_CAMPAIGNS_QUESTION_LOG_VERSION) return false;
      var recordedCampaigns = Object.values((0, _omit["default"])(localStorageLog.campaigns, ['version']));
      return recordedCampaigns.every(function (campaign) {
        return campaign.instructions;
      });
    });
    //answer question
    _initializerDefineProperty(this, "answerQuestion", _descriptor15, this);
    _defineProperty(this, "pickFollowup", function (_ref2) {
      var followUps = _ref2.followUps,
        answer = _ref2.answer;
      var followUp = followUps && followUps.find(function (q, idx) {
        if (q.rangeFrom <= answer && answer <= q.rangeTo) {
          q.idx = idx;
          return true;
        }
        return false;
      });
      return followUp;
    });
    _defineProperty(this, "answerFollowup", function () {
      _this.setIsReadyToSubmit(true);
    });
    _defineProperty(this, "submitSignOff", function (_ref3) {
      var instructionId = _ref3.instructionId,
        mutation = _ref3.mutation,
        nextButton = _ref3.nextButton;
      if ((0, _get["default"])(_this, 'store.analytics.posthogIsLoaded', false)) {
        (0, _posthogUtils.posthogCapture)('Click Submit Signoff');
      }
      var _this$activeQuestion = _this.activeQuestion,
        campaignId = _this$activeQuestion.campaignId,
        locale = _this$activeQuestion.locale;
      var _this$form$values = _this.form.values(),
        answer = _this$form$values.answer,
        followUpAnswer = _this$form$values.followUpAnswer,
        user = _this$form$values.user;
      var _this$store = _this.store,
        instructionPage = _this$store.instructionPage,
        platform = _this$store.platform;
      _this.updateLocalStorageLog({
        campaignId: campaignId,
        instructionId: instructionId
      });
      mutation({
        answer: {
          anonymousUser: (0, _dataUtils.anonymousUserId)(),
          answer: answer,
          campaignQuestionLocale: locale,
          followUpAnswer: followUpAnswer,
          guideVersionId: instructionPage.currentGuideVersionId,
          instructionId: instructionId,
          questionId: campaignId,
          user: user,
          userPlatformLocale: platform.getLanguage()
        }
      }).then(function () {
        _this.setIsReadyToSubmit(false);
        _this.setIsSubmitted(true);
        _this.resetQuestions();
        if (nextButton) {
          nextButton.click();
        }
      }, function (error) {
        _ravenJs["default"].captureException(error);
        _this.setIsSubmissionFailureModalOpen(true);
      });
    });
    (0, _mobx.makeObservable)(this);
  }
  return _createClass(CampaignStore, [{
    key: "step",
    get:
    //computed values
    function get() {
      if (this.isSubmitted) {
        return 'thank-you';
      }
      if (this.isReadyToSubmit) {
        return 'summary';
      }
      if (!(0, _isEmpty["default"])(this.followupQuestion)) {
        return 'follow-up-question';
      }
      if (!(0, _isEmpty["default"])(this.activeQuestion)) {
        return 'question';
      }
      return 'none';
    }
  }, {
    key: "updateLocalStorageLog",
    value: function updateLocalStorageLog(_ref4) {
      var campaignId = _ref4.campaignId,
        instructionId = _ref4.instructionId;
      var currentLog = this.getLocalStorageLog();
      var timestamp = Date.now();
      var updatedLog = _objectSpread({}, currentLog);
      if (!updatedLog.campaigns[campaignId]) {
        updatedLog.campaigns[campaignId] = {
          instructions: {}
        };
      }
      updatedLog.campaigns[campaignId].instructions[instructionId] = timestamp;
      localStorage.setItem(_campaignStoreConstants.LOCAL_STORAGE_CAMPAIGN_QUESTION_LOG, JSON.stringify(updatedLog));
    }
  }]);
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "activeQuestion", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "followupQuestion", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isReadyToSubmit", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isSubmitted", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "lastDateOfAnswerForUser", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isSubmissionFailureModalOpen", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "setLastDateOfAnswerForUser", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;
    return function (val) {
      _this2.lastDateOfAnswerForUser = val;
    };
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "setActiveQuestion", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;
    return function (campaign) {
      _this3.activeQuestion = _objectSpread(_objectSpread({}, campaign.question), {}, {
        campaignId: campaign.id
      });
      _this3.lastDateOfAnswerForUser = campaign.lastDateOfAnswerForUser;
    };
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "setIsReadyToSubmit", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;
    return function (isReadyToSubmit) {
      _this4.isReadyToSubmit = isReadyToSubmit;
    };
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "setIsSubmitted", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this5 = this;
    return function (isSubmitted) {
      _this5.isSubmitted = isSubmitted;
    };
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "setFollowupQuestion", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this6 = this;
    return function (followupQuestion) {
      _this6.followupQuestion = followupQuestion;
    };
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "setIsSubmissionFailureModalOpen", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this7 = this;
    return function (isSubmissionFailureModalOpen) {
      _this7.isSubmissionFailureModalOpen = isSubmissionFailureModalOpen;
    };
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "resetQuestions", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this8 = this;
    return function () {
      _this8.resetActiveQuestion();
      _this8.followupQuestion = {};
      _this8.form.reset();
    };
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "resetActiveQuestion", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this9 = this;
    return function () {
      _this9.activeQuestion = {};
      _this9.lastDateOfAnswerForUser = null;
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "step", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "step"), _class.prototype), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "answerQuestion", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this10 = this;
    return function () {
      if ((0, _get["default"])(_this10, 'store.analytics.posthogIsLoaded', false)) {
        (0, _posthogUtils.posthogCapture)('Signoff Question Answered');
      }
      var followupQuestion = _this10.pickFollowup({
        followUps: _this10.activeQuestion.followUps,
        answer: _this10.form.$('answer').value
      });
      if (followupQuestion) {
        _this10.followupQuestion = followupQuestion;
      } else {
        _this10.setIsReadyToSubmit(true);
      }
    };
  }
})), _class);
var _default = exports["default"] = CampaignStore;
//# sourceMappingURL=campaign.js.map